<mat-form-field [formGroup]="group" class="full-width">
	<mat-label>{{ config.placeholder }}</mat-label>
	<input
		matInput
		placeholder="{{ config.placeholder }}"
		[formControlName]="config.name"
		[disabled]="config.disabled" />
</mat-form-field>
